/*SP画面vh調整用*/
$(window).on('load resize', function(){
  var height = $(window).innerHeight();
  $(":root").css('--vh', height/100 + 'px');
});

//inviewフェードイン
$(function () {
  var fade = $('.fade');
  fade.css('transition', 'opacity .5s ease-in-out, transform .5s ease-in-out');
  fade.on('inview', function () {
    $(this).removeClass('fade');
  });
});

//TOPへ戻るスクロール
$(function () {
  $("#btn_pagetop").click(function() {
    $('body, html').animate({scrollTop: 0}, 300, 'linear');
  });
});

// KVスライドショー
function kvSlider(){
	var fps = 100;		//何フレームで描画するか
	var size = 0;		//表示時間を表すメーターの幅（単位は％）
	var duration = 4.5;	//何秒でスライドを切り替えるか
  
  var fade = 250;//画像フェイド速度(切り替えよりは早く)
  var ext = ".jpg?0002";//画像拡張子
  
  var slImg = "#slide picture";
  
  var meter = "#paging li";
  var mActive = meter + ".active";
  var bar = " span";
		
	//スライドの切り替えと表示時間を描画するためのタイマー
	var slideTimer = setInterval(function(){
		//メーターの描画
		$(mActive + bar).css('height',size+'%');
		size += 100/(duration*fps);
		//100%を超えたらスライドの切り替え
		if(size > 100){
			//activeを持っているli要素が最後だったら最初のli要素を、それ以外は次のli要素がクリックされたことにする
			if($(mActive).index() === $(meter).length-1){
				$(meter + ':first-child').click();
			}else{
				$(mActive).next().click();
			}
		}
	},1000/fps);	

	//ボタンをクリックしたときの処理
	$(meter).click(function(){
		//メーターのリセット	
		size = 0;
		$(meter + bar).css('height',size+'%');
		//連続クリックによる大量挿入を防ぐためのif文
		if(!$(this).hasClass('active')){
			$(mActive).removeClass('active');
			$(this).addClass('active');
          
          	//↓↓ 2021/07/21 背景画像上にテキストを表示 ↓↓ 
            //画像と文字を結びつけるために画像名の末尾の数字を取得
            let fileNameUrl = $(mActive).attr('data-src').split("/").filter(e => Boolean(e));
            let fileName = fileNameUrl[fileNameUrl.length - 1];
            let numberKeyValue = fileName;

          
          	//画像に重ねて表示する文字要素
          	let textDivClassValue = 'caption-area area' + numberKeyValue;
          	let textDivIdValue = 'caption-area' + numberKeyValue;
            var textDivHtml = '<div class="' + textDivClassValue + '" id="' + textDivIdValue + '">' + $('#' + textDivIdValue).html() + '</div>' 

            //スライド画像置き換え(pictureタグの末尾に文字追加)
            $(slImg).before('<picture><source media="(min-width: 420px)" srcset="' + $(mActive).attr('data-src') + ext + '"><source srcset="' + $(mActive).attr('data-src') + '_sp' + ext + '"><img src="' + $(mActive).attr('data-src') + ext + '" alt="">' + textDivHtml + '</picture>');
      		//↑↑ 2021/07/21 背景画像上にテキストを表示 ↑↑
          
          // 			$(slImg).before('<picture><source media="(min-width: 420px)" srcset="' + $(mActive).attr('data-src') + ext + '"><source srcset="' + $(mActive).attr('data-src') + '_sp' + ext + '"><img src="' + $(mActive).attr('data-src') + ext + '" alt=""></picture>');
			$(slImg + ':not(:first)').fadeOut(fade, function(){
				$(this).remove();
			});
		}
	});	
}

//超吸収型サニタリーショーツとは？SP展開
function about_sanitary(){
	var Btn = $('.about_title button')
	Btn.click(function() {
  if(!$(this).parent().next().is(':animated')){
      $(this).parent().next().slideToggle('fast');
      $(this).toggleClass('btn_clause');
    } 
	});
}

//PRODUCTS バーフェイドイン
function main_product_bar(bar){
  var newBar;

  bar.each(function(){
    newBar = "";
    var content = $(this).html();
    var text = $.trim(content);
    text.split("").forEach(function(i) {
        newBar += "<span>" + i + "</span>";
    });
    $(this).html(newBar);
  });
  
  bar.on('inview', function () {
    $(this).children('span').each(function(j){
      $(this).delay(j*(200)).animate({
        'opacity' : '1'
      },200);
    });
  });
}

//PRODUCTS 吸水量グラフ順にフェードイン
function graph_fade(){
  var obj = $("#product_details .a_graph");
  
  obj.on('inview', function () {
    $(this).children().each(function(i){
      $(this).delay(500*i).queue(function(){
          $(this).css('opacity',1).dequeue();
      });
    });
  });
}

//メディア掲載情報スライド
function topMediaSlide(){
  var slArea = $('.top_media .swiper-container');
  var sTag = '<div class=' + '"';
  var cTag = '"' + '>';
  var eTag = '</div>';

  slArea.append(sTag + 'sw_prev' + cTag + "&#xff1c;" + eTag + sTag + 'sw_next' + cTag + "&#xff1e;" + eTag + eTag);	

  var swiper = new Swiper(slArea, {
      slidesPerView: "auto",
      navigation: {
      nextEl: '.sw_next',
      prevEl: '.sw_prev',
      },
      speed: 1500
  });
} 

//TOP PROMOTION
function topPromoHeight() {
  //高さの最大値を代入するための変数h
  var h = 0; 
  
  //それぞれの要素の高さを調べる
  $("ul.swiper-promotion li a").each(function(){
    // 要素の高さをと変数hの値を比較し、大きい方を変数hに代入します
    if($(this).outerHeight() > h) {
      h = $(this).outerHeight();
    }
  });
  // 要素の高さを変数hの値に統一します
  $("ul.swiper-promotion li a").css("height", h + "px");
}

//TOP RECOMMEND
function topRecomHeight() {
  var h = 0; 
  $("ul.swiper-recommend li a").each(function(){
    if($(this).outerHeight() > h) {
      h = $(this).outerHeight();
    }
  });
  $("ul.swiper-recommend li a").css("height", h + "px");
}

//ポップアップウィンドウ
function pUp(btn){
  btn.click(function() {
    $(this).next().fadeIn().css('display','flex');
  });
  
  $('.pop_up button').click(function() {
    $('.pop_up').fadeOut();
  });
} 

//商品詳細 商品名追従バー
function productNameBar(){
  var nameBar = $('#bar_product_name');
  $(window).on('load scroll', function (){
    if ($(this).scrollTop() > 500) {
      nameBar.fadeIn().css('display','flex');
     }else {
      nameBar.fadeOut();
    }
  });
} 

//コピーボタン
function copyToClipboard() {
  var copyBtn = $('#btn_copy');
  var copyArea = $('.gift_code input');
  
  function copyTo() {
    copyArea.select();
    document.execCommand("Copy");
    alert("コピーしました");
  }
  
  copyBtn.click(function() {
	copyTo();
  });

  copyArea.on('contextmenu', () => {
	copyTo();
  });
}

//シークレットページ 購入ボタン制御
function btnSecret(){
  var nameBar = $('.ProductForm__AddToCart, .shopify-payment-button');
  var txtBox = $('.secret_pw_area input[type="text"]'); 
  var key = $('#secret-password'); 
  var key_02 = $('#secret-password_02');
  var txtBoxAfter = $('.secret_pw_area select'); 
  var key_03 = $('#secret-password_03'); 

  if(key_02.length){
    txtBox.blur(function(){
      var keyVal_01 = key.val();
      var keyVal_02 = key_02.val();     
      if (keyVal_01.length && keyVal_02.length) {
        nameBar.addClass('btn_on');
      }else{
        nameBar.removeClass('btn_on');
      }
    });    
  }else if(key_03.length){
    txtBoxAfter.blur(function(){
      var keyVal_01 = key.val();
      var keyVal_03 = key_03.val();     
      if (keyVal_01.length && keyVal_03 !== '未回答') {
        nameBar.addClass('btn_on');
      }else{
        nameBar.removeClass('btn_on');
      }
    });    
  }else{
    key.blur(function(){
      var keyVal = $(this).val();

      if (keyVal.length) {
        nameBar.addClass('btn_on');
      }else{
        nameBar.removeClass('btn_on');
      }
    });
  }

  nameBar.keydown(function(e) {
    var keyVal = key.val();
    
    if (!keyVal.length) {
      if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
        return false;
      } else {
        return true;
      }
    }
  });
  
  txtBox.keydown(function(e) {
    if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
      return false;
    } else {
      return true;
    }
  });

  
} 

// クッキーバナー
function cookieBnr(){
  var Bnr = $('#bnr_cookie_non_member');

  if(Cookies.get('cookieBnr') != 'Off'){
    Bnr.fadeIn().css('display','flex');
  }

  Bnr.find('button').click(function(){
    Cookies.set('cookieBnr', 'Off', {expires: 1});
    Bnr.fadeOut();
  })
}

// ★★★ヘッダーカート数量アイコンのリアルタイム更新★★★
document.addEventListener('DOMContentLoaded', function () {
  console.log('[cart-header-sync] init');

  function updateHeaderCartCount(count) {
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshHeaderCartCount() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        console.log('[cart-header-sync] cart.item_count =', cart.item_count);
        updateHeaderCartCount(cart.item_count);
      })
      .catch(function (err) {
        console.error('[cart-header-sync] /cart.js error', err);
      });
  }

  // ページ全体で「data-action='add-to-cart'」のクリックを横取り
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="add-to-cart"]');
    if (!btn) return;

    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) {
      console.warn('[cart-header-sync] form not found for add-to-cart button');
      return;
    }

    e.preventDefault();
    console.log('[cart-header-sync] click intercepted for', form.id || form);

    btn.setAttribute('disabled', 'disabled');

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            console.error('[cart-header-sync] /cart/add.js error', err);
            throw err;
          });
        }
        console.log('[cart-header-sync] add.js success');
        return refreshHeaderCartCount();
      })
      .then(function () {
        btn.removeAttribute('disabled');
      })
      .catch(function (err) {
        console.error('[cart-header-sync] error', err);
        btn.removeAttribute('disabled');
        // 必要なら form.submit() にフォールバックもOK
      });
  });
  //カート関連の処理が終わるたびに最新の数量を反映
  document.addEventListener('theme:loading:end', function () {
    refreshHeaderCartCount();
  });
});